export const unslugify = (str: string) => str.replace(/-/g, " ").replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
